<template>
    <div>
        <div class="inline-form-group">
            <el-form-item label="Wyświetlaj nazwę"
                          :error="errors['display_name']">
                <el-switch v-model="form['display_name']"/>
            </el-form-item>
            <el-form-item label="Nazwa"
                          :error="errors[addLanguageSuffix('name')]"
                          required>
                <el-input v-model="form[addLanguageSuffix('name')]"
                          placeholder="Nazwa widgetu"/>
            </el-form-item>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['form', 'errors']
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// BaseWidget.vue?384ec880